import 'prop-types';
import * as React from 'react';

var useFocusItem = function useFocusItem(items) {
  var focusItemRef = React.useRef();
  var keyMirror = {};
  Object.keys(items).forEach(function (v) {
    keyMirror[v] = v;
  });
  return {
    focusItem: function focusItem() {
      var _items$focusItemRef$c, _items$focusItemRef$c2;

      return focusItemRef.current && ((_items$focusItemRef$c = items[focusItemRef.current]) === null || _items$focusItemRef$c === void 0 ? void 0 : (_items$focusItemRef$c2 = _items$focusItemRef$c.current) === null || _items$focusItemRef$c2 === void 0 ? void 0 : _items$focusItemRef$c2.focus());
    },
    itemKeys: keyMirror,
    setFocusItem: function setFocusItem(item) {
      focusItemRef.current = item;
    }
  };
};

export { useFocusItem };
